import * as React from 'react';

import { sections } from 'components/lexemes';
import { CdnImagePath } from 'lib/cdn-image-path';

import { SectionContentLinkListIdSeven } from 'components/section-content-link-list';
import { TitleAnchor } from 'components/title-anchor';
import { FormattedText, P1 } from 'components/typography';

const setTitleElement = (id: SectionContentLinkListIdSeven) => {
  const mapTitleAnchorToSectionId: {
    [key in SectionContentLinkListIdSeven]: {
      id: SectionContentLinkListIdSeven;
      title: string;
    };
  } = {
    [SectionContentLinkListIdSeven.TipsToKeepYourDataSecure]: {
      id: SectionContentLinkListIdSeven.TipsToKeepYourDataSecure,
      title: `${sections.tabSevenSection.tab.list()[0]}`,
    },

    [SectionContentLinkListIdSeven.AgeRestrictionPolicy]: {
      id: SectionContentLinkListIdSeven.AgeRestrictionPolicy,
      title: `${sections.tabSevenSection.tab.list()[1]}`
        // @TODO: discus with LOC-team - remove  number
        .replace('2. ', ''),
    },
  };
  return <TitleAnchor {...mapTitleAnchorToSectionId[id]} />;
};

export const getPropsSectionSevenContainer = () => {
  /**
   * @todo: add real text
   */
  return {
    sections: {
      one: {
        id: SectionContentLinkListIdSeven.TipsToKeepYourDataSecure,
        titleElement: setTitleElement(SectionContentLinkListIdSeven.TipsToKeepYourDataSecure),
        text: (
          <FormattedText>
            <P1 html={sections.tabSevenSection.section1.text1()} as="p" />
            <P1 html={sections.tabSevenSection.section1.text2()} as="p" />
            <P1 html={sections.tabSevenSection.section1.text3()} as="div" />
            <P1 html={sections.tabSevenSection.section1.text4()} as="p" />
          </FormattedText>
        ),
      },
      two: {
        titleElement: setTitleElement(SectionContentLinkListIdSeven.AgeRestrictionPolicy),
        text: (
          <FormattedText>
            <P1 html={sections.tabSevenSection.section2.text1()} as="p" />
            <P1 html={sections.tabSevenSection.section2.text2()} as="p" />
          </FormattedText>
        ),
        imageSrc: `${CdnImagePath}/assets/tab-07/tab-07-02.jpg`,
        imageAlt: '',
        imageObjectPosition: 'top center',
      },
    },
  };
};
